import * as http from './http';
import { stringify } from 'query-string';
import ApiService from './service';
import {
  PaginatedApiResponse,
  ApiResponse,
  Showroom,
  CreateShowroomShift,
  CreateStaffShift,
  ShowroomShift,
  StaffShift,
  ShowroomShiftGrouped,
} from '../models';
import { Dict } from '../../models';
const serviceEndpoint = 'api/showroom';

export class ShowroomService extends ApiService {
  public async loadAllShowroom(data?: {
    page?: number;
    ecommerceOnly?: boolean;
  }): Promise<PaginatedApiResponse<Showroom>> {
    const url = `${this.apiDomain}/${serviceEndpoint}?${stringify(data || {})}`;

    const resposne = await http.get<PaginatedApiResponse<Showroom>>(
      url,
      this.store
    );
    return { ...resposne.data };
  }

  public async createShowroom(data: Showroom) {
    const url = `${this.apiDomain}/${serviceEndpoint}`;

    const response = await http.post<ApiResponse<Showroom>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }

  public async updateShowroom(data: Showroom, id?: string) {
    const url = `${this.apiDomain}/${serviceEndpoint}/${id}`;

    const response = await http.put<ApiResponse<Showroom>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }

  public async removeShowroom(id?: string) {
    const url = `${this.apiDomain}/${serviceEndpoint}/${id}`;

    const response = await http.remove<ApiResponse<Showroom>>(url, this.store);

    return response?.data?.data;
  }

  public async loadShowroomShift(data: {
    page: number;
  }): Promise<PaginatedApiResponse<ShowroomShift>> {
    const url = `${this.apiDomain}/${serviceEndpoint}/shift?${stringify(data)}`;

    const resposne = await http.get<PaginatedApiResponse<ShowroomShift>>(
      url,
      this.store
    );
    return { ...resposne.data };
  }

  public async loadShowroomShiftGrouped(
    showroomId?: string
  ): Promise<ShowroomShiftGrouped> {
    const url = `${this.apiDomain}/${serviceEndpoint}/shift/grouped?showroomId=${showroomId}`;

    const resposne = await http.get<ApiResponse<ShowroomShiftGrouped>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async createShowroomShift(data: CreateShowroomShift) {
    const url = `${this.apiDomain}/${serviceEndpoint}/shift`;

    const response = await http.post<ApiResponse<CreateShowroomShift>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }

  public async updateShowroomShift(data: CreateShowroomShift, id?: string) {
    const url = `${this.apiDomain}/${serviceEndpoint}/shift/${id}`;

    const response = await http.put<ApiResponse<CreateShowroomShift>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }

  public async removeShowroomShift(id?: string) {
    const url = `${this.apiDomain}/${serviceEndpoint}/shift/${id}`;

    const response = await http.remove<ShowroomShift>(url, this.store);

    return response?.data;
  }

  public async createStaffShift(data: CreateStaffShift) {
    const url = `${this.apiDomain}/${serviceEndpoint}/staff-shift`;

    const response = await http.post<ApiResponse<CreateStaffShift>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }

  public async updateStaffShift(data: CreateStaffShift, id?: string) {
    const url = `${this.apiDomain}/${serviceEndpoint}/staff-shift/${id}`;

    const response = await http.put<ApiResponse<CreateStaffShift>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }

  public async loadStaffShift(showroomId: string): Promise<StaffShift[]> {
    const url = `${this.apiDomain}/${serviceEndpoint}/staff-shift?showroomId=${showroomId}`;

    const resposne = await http.get<ApiResponse<StaffShift[]>>(url, this.store);
    return resposne?.data?.data;
  }

  public async removeStaffShift(id?: string) {
    const url = `${this.apiDomain}/${serviceEndpoint}/staff-shift/${id}`;

    const response = await http.remove<StaffShift>(url, this.store);

    return response?.data;
  }

  public async getShowroom(id?: string): Promise<Showroom> {
    const url = `${this.apiDomain}/api/showroom/${id}`;
    const response = await http.get<ApiResponse<Showroom>>(url, this.store);
    return response?.data?.data;
  }

  public async getShowroomByLocationCode(id?: string): Promise<Showroom> {
    const url = `${this.apiDomain}/api/auth/showroom/${id}`;
    const response = await http.get<ApiResponse<Showroom>>(url, this.store);
    return response?.data?.data;
  }
}
